<script>
	import request from './request.vue';
	import Category from './category.model.vue';

	import { format } from "date-fns";

	const courseSchema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "Digite o código da empresa",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "name",
			displayName: "Nome",
			kind: "text",
			validation: "required",
			placeholder: "Digite o nome do curso",
			defaultSort: true,
			notInFilters: false,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			notInFilters: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "videoUrl",
			displayName: "Video",
			kind: "file-url",
			validation: "",
			placeholder: "",
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("video", `uploadVideo/${id}`, formData);
				console.log(response);
				return response.data;
			},
		},
		{
			name: "categoryId",
			displayName: "Categoria",
			validation: "required",
			kind: "select",
			placeholder: "",
			options: [],
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
	];

	Category.getAll()
		.then((categories) => {
			courseSchema.find(field => field.name === "categoryId").options = categories.map(category => ({
				name: category.name,
				value: category.id,
			}));
		})
		.catch((err) => console.log(err));

	export default {
		create: async function (entity) {
			const response = await request.send("video", "create", entity, true);
			return response.data;
		},
		getInfo: async function (id) {
			const response = await request.send("video", "read", { id }, true);
			return response.data;
		},
		updateInfo: async function (course) {
			let response = await request.send("video", "update", course, true);
			return response.data;
		},
		remove: async function (id) {
			return request.send("video", "delete", { id }, true);
		},
		search: async function(parameters) {
			return request.send("video", "search", parameters, true);
		},
		uploadVideo: async function(id, video) {
			return request.sendFormData("video", `uploadVideo/${id}`, video, true);
		},
		getSchema: function () {
			return courseSchema;
		},
	}
</script>
